import { formatFileSize } from "./helpers/functions";

export const MAX_AVATAR_SIZE = 50000000; // 50 MB
export const FORMATED_AVATAR_SIZE = formatFileSize(MAX_AVATAR_SIZE);

export const STATE_COOKIE_KEY = "oAuthState";
export const CODE_VERIFIER_COOKIE_KEY = "oAuthCodeVerifier";
//
export const COOKIE_EXPIRATION_SECONDS = 60 * 10;

export const OTP_VERIFY_KEY = "OTP";
export const OTP_EXPIRATION_SECONDS = 60 * 10;

export const SESSION_EXPIRATION_SECONDS = 60 * 60 * 24 * 7;
export const COOKIE_SESSION_KEY = "session-id";

export const RESET_TOKEN_EXPIRY = 60 * 15;
export const RESET_TOKEN_KEY = "reset_token";

export const SET_RENDER_TOP = "SET_RENDER_TOP";
export const START_TOP_LOADING = "START_TOP_LOADING";
export const END_TOP_LOADING = "END_TOP_LOADING";
export const START_BOTTOM_LOADING = "START_BOTTOM_LOADING";
export const END_BOTTOM_LOADING = "END_BOTTOM_LOADING";
export const SET_FETCHING = "SET_FETCHING";

export const BOOKMARK_TABLE_NAME = "liked-ayats";
export const BOOKMARK_DB_NAME = "bookmarks";
export const BOOKMARK_DB_VERsION = 1;
export const BOOKMARK_DB_KEY_NAME = "id";

export const LOCALSTORAGE_NOTES_KEY = "notes";

export const QURAN_DATABASE_NAME = "quran-pages";
export const QURAN_DATABASE_VERSION = 1;
export const QURAN_DATABASE_KEY_NAME = "id";
export const QURAN_DATABASE_TABLES = [
  "hafs1",
  "hafs2",
  "indopak15",
  "indopak16",
];

export const QURAN_WBW_DATABASE_NAME = "wbwtranslations";
export const QURAN_WBW_DATABASE_VERSION = 1;
export const QURAN_WBW_DATABASE_KEY_NAME = "id";
export const QURAN_WBW_DATABASE_TABLES = [
  "al",
  "bn",
  "cnp",
  "cns",
  "cnt",
  "en",
  "fr",
  "gr",
  "hi",
  "in",
  "ig",
  "ml",
  "pr",
  "ru",
  "sn",
  "ta",
  "tu",
  "ur",
];

export const QURAN_TRANSLATIONS_DATABASE_NAME = "translations";
export const QURAN_TRANSLATIONS_DATABASE_VERSION = 1;
export const QURAN_TRANSLATIONS_DATABASE_KEY_NAME = "verse_id";
export const Quran_TRANSLATIONS_DATABASE_TABLES = [
  "1",
  "19",
  "20",
  "22",
  "23",
  "25",
  "26",
  "27",
  "29",
  "30",
  "31",
  "32",
  "33",
  "35",
  "36",
  "37",
  "38",
  "39",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "74",
  "75",
  "76",
  "77",
  "78",
  "79",
  "80",
  "81",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "89",
  "95",
  "97",
  "101",
  "103",
  "106",
  "108",
  "109",
  "111",
  "112",
  "113",
  "115",
  "118",
  "120",
  "122",
  "124",
  "125",
  "126",
  "127",
  "128",
  "131",
  "133",
  "134",
  "135",
  "136",
  "139",
  "140",
  "141",
  "143",
  "144",
  "151",
  "153",
  "156",
  "158",
  "161",
  "162",
  "163",
  "199",
  "203",
  "208",
  "209",
  "210",
  "211",
  "213",
  "214",
  "217",
  "218",
  "219",
  "220",
  "221",
  "222",
  "223",
  "224",
  "225",
  "226",
  "227",
  "228",
  "229",
  "230",
  "231",
  "232",
  "233",
  "234",
  "235",
  "236",
  "237",
  "238",
  "771",
  "774",
  "779",
  "782",
  "785",
  "795",
  "796",
  "798",
  "819",
  "831",
  "840",
];
